export enum RouteName {
  List = 'WF-invoice-list',
}
